import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { valueStrings } from "../../constants/constantStrings";
import { BaselineStrings } from "../../constants/constantStrings";

const BaselineDeleteModal = ({ open, handleClose, handleSubmit }) => {
  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <div className="confirmationContainer">
        <div className="whiteMainHeadingText">{BaselineStrings.baselineDelete} </div>
        <div className="whiteSecondaryHeadingText padding20">{BaselineStrings.baselineDeleteWarning} </div>
        <div className="btnConfirmationContainer">
          <div className="btnNo" onClick={handleClose}>
            {valueStrings.cancel}
          </div>
          <div className="btnYes" onClick={handleSubmit}>
            {valueStrings.delete}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default BaselineDeleteModal;
